<template lang="pug">
div.search-input-text(
    v-bind:class="getClassName()")

    dx-autocomplete(
        ref="dxAutocomplete"
        v-bind:tab-index="0"
        v-bind:data-source="autocomplete"
        v-bind:placeholder="placeholder"
        v-bind:value="value.Text"
        v-bind:disabled="disabled"
        v-on:initialized="onInitialized"
        v-on:value-changed="value.Text = $event.value"
        v-on:enter-key="onEnter")

    component(
        v-if="ready"
        v-bind:is="icon" title=''
        v-on:click="onEnter")

    // input(type="text"
    //     id="search-text-input"
    //     class="input form-control"
    //     v-model="value.Text"
    //     v-on:keyup.enter="onEnter"
    //     v-bind:placeholder="placeholder"
    //     v-bind:autofocus="autofocus")

</template>

<script>
export default {
    name: 'search-option-input-text',

    props: {
        // value is the v-model and mutated directly
        value: {        type: Object, required: true },
        onEnter: {      type: Function, required: true },
        autofocus: {    type: Boolean },
        placeholder: {  type: String },
        icon: {         type: String, default: 'icon-magnify' },
        autocomplete: { type: Array[String], default: () =>  { return []; } },
        disabled: {     type: Boolean }
    },

    components: {
        DxAutocomplete: () => import('devextreme-vue/autocomplete')
    },

    data: function () {
        return {
            ready: false
        };
    },

    methods: {
        getClassName: function () {
            return this.disabled ? 'disabled' : '';
        },

        onInitialized: function () {
            this.ready = true;
        }
    }
};
</script>

<style lang="scss">
// @import '~assets/styles/variables';

.search-input-text {
    display: flex;
    flex-grow: 1;
    margin: 0;
    margin-bottom: 20px;
    .dx-texteditor-input-container {
        align-items: baseline;
        font-family: $sabon-roman;
        font-size: 1.5rem;
        line-height: 2;
    }
    input, .dx-texteditor-input {
        display: inline-flex;
        height: auto;
        padding: 0 3rem 0 1rem !important;
        line-height: 2 !important;
        border: 1px solid $medium-gray-3;
        border-color: $medium-gray-3;
        &:focus {
            border-color: $medium-gray;
            outline: none;
            box-shadow: none;
        }
    }
    .dx-textbox {
        width: 100%;
        height: 50px; // for IE
        height: min-content;
    }
    .dx-placeholder {
        display: inline-flex;
        align-self: flex-start;
        padding: 0 3rem 0 1rem;
        font-family: $sabon-roman;
        font-size: 1.5rem;
        line-height: 2;
        color: $medium-gray-2;
        &::before {
            padding: 0 !important;
        }
    }
    .material-design-icon {
        position: relative;
        z-index: 10;
        display: inline-flex;
        align-self: center;
        width: 32px;
        height: 32px;
        margin-top: 0.5rem;
        color: $dark-gray-2;
        cursor: pointer;
        transform: translateX(-45px);
        &.magnify-icon {
            align-self: baseline;
            margin-top: 10px;
        }
    }
}
</style>
